import type { FC } from 'react';
import type { SingleFormField } from '../../../typings';
import { singleFieldInnerPresenterRegistry } from './single-field-inner-presenter.registry';
import './single-field-inner-presenter-registry.init';
import { useSingleFieldInnerPresenterContext } from './useSingleFieldInnerPresenterContext';

type SingleFieldInnerPresenterProps = {
  field: SingleFormField;
  disabled?: boolean;
};

export const SingleFieldInnerPresenter: FC<SingleFieldInnerPresenterProps> = ({
  field,
  disabled,
}) => {
  const ctx = useSingleFieldInnerPresenterContext(field, disabled);
  return singleFieldInnerPresenterRegistry.render(field.type, ctx);
};
